import * as React from 'react'

const SvgBed = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={215}
    height={90}
    viewBox="0 0 215 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Bed_svg__a)">
      <path
        d="M88.362 0H14.414C6.456 0 0 6.51 0 14.534v75.46h5.178V73.141h92.413v16.853h5.179v-75.46C102.77 6.509 96.314 0 88.356 0h.006Z"
        fill="#7130C9"
      />
      <path
        d="M11.565 38.42h115.808v43.154H.006V50.076c0-6.434 5.178-11.655 11.559-11.655Z"
        fill="#E1CEFF"
      />
      <path
        d="M128.968 38.42h80.854v43.154h-92.413V50.076c0-6.434 5.178-11.655 11.559-11.655Z"
        fill="#9865FC"
      />
      <path
        d="M127.373 38.42h60.932c6.381 0 11.559 5.222 11.559 11.656v23.071h-72.491V38.421ZM45.733 15.53H15.269c-1.596 0-2.89 1.305-2.89 2.914v17.063c0 1.61 1.294 2.914 2.89 2.914h30.464c1.595 0 2.89-1.305 2.89-2.914V18.444c0-1.61-1.295-2.914-2.89-2.914ZM87.512 15.53H57.049c-1.596 0-2.89 1.305-2.89 2.914v17.063c0 1.61 1.294 2.914 2.89 2.914h30.463c1.596 0 2.89-1.305 2.89-2.914V18.444c0-1.61-1.294-2.914-2.89-2.914Z"
        fill="#fff"
      />
      <path
        d="M200.592 29.493h-73.948c-7.958 0-14.414 6.51-14.414 14.534V90h5.179V73.147h92.413V90H215V44.027c0-8.025-6.456-14.534-14.414-14.534h.006Z"
        fill="#7130C9"
      />
    </g>
    <defs>
      <clipPath id="Bed_svg__a">
        <path fill="#fff" d="M0 0h215v90H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBed
